import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MasonryModule } from 'angular2-masonry';

import { MyTimesheetsComponent } from './components/my-timesheets/my-timesheets.component';
import { EmployeeTimesheetsComponent } from './components/employee-timesheets/employee-timesheets.component';
import { ConfigurationComponent } from './components/configuration/configuration.component';


import { TimeComponent } from './time.component';

import { TimeReportService } from './services/time-report.service';

//Routing
import { mainRouting } from '../main.routes';
import { PunchInOutComponent } from './components/punch-in-out/punch-in-out.component';
import { MyRecordsComponent } from './components/my-records/my-records.component';
import { EmployeeRecordsComponent } from './components/employee-records/employee-records.component';
import { AttendanceTimeSummaryComponent } from './components/reports/attendance-time-summary/attendance-time-summary.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MasonryModule,
    
    mainRouting
  ],
  declarations: [
    MyTimesheetsComponent,
    TimeComponent,
    EmployeeTimesheetsComponent,
    PunchInOutComponent,
    MyRecordsComponent,
    EmployeeRecordsComponent,
    ConfigurationComponent,
    AttendanceTimeSummaryComponent
  ],
  providers: [TimeReportService]
})
export class TimeModule { }



// WEBPACK FOOTER //
// ./src/app/modules/time/time.module.ts